<template>
  <w-sliding-popup ref="slidingPopup" type="setting" title="임계치 가이드 스케줄 설정" width="550px" :default-content="false" @close="onClosePopup">
    <div slot="content" class="body-content-no-scroll" style="height:100%;">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="vertical-center-box">
          <span class="title-h4 dot-title">스케줄 정보</span>
          <el-switch v-model="scheduleData.SCHEDULE_APPLY_FLAG" active-value="Y" inactive-value="N"/>
        </div>
      </el-row>
      <el-form :disabled="isEditMode" label-position="top" :model="scheduleData">
        <div class="mr-b25">
          <el-form-item label="시작일">
            <el-date-picker class="mr-r4" size="small" style="width: 220px;" :editable="false" type="date" v-model="startDatetime" :start-placeholder="defaultDateRangeOptions.startPlaceholder" :end-placeholder="defaultDateRangeOptions.endPlaceholder"
             :picker-options="defaultDateRangeOptions.pickerOptions" :defaultTime="defaultDateRangeOptions.defaultTime" format="yyyy-MM-dd" :clearable="false">
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="title-bar title-h4 dot-title">주기 설정</div>
        <w-guide-period-setting-component class="mr-b25" ref="periodSettingCmp" />
      </el-form>
    </div>
    <el-row slot="footer" type="flex" justify="center">
      <el-button class="mr-r4" type="solid" size="large" @click="onClickSaveButton">저장</el-button>
      <el-button size="large" @click="onClosePopup">취소</el-button>
    </el-row>
  </w-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import moment from 'moment';
import { isEmpty } from 'lodash';
import { defaultDateRangeOptions, removeTime, getDateToString } from '@/utils/date';
import EventGuideSettingsAPI from '@/api/settings/common/event-guide-settings';
import WGuidePeriodSettingComponent from '../components/GuidePeriodSettingComponent';


export default {
  name: 'WPeriodSettingPopup',
  components: {
    WGuidePeriodSettingComponent,
  },
  props: {
    periodInfo: {
      type: Object,
    },
  },
  data() {
    return {
      defaultDateRangeOptions,
      scheduleData: {},
      startDatetime: removeTime(new Date()),
      scheduletest: false,
      scheduleApplyFlag: false,
    };
  },
  computed: {
    isEditMode() {
      return (!isEmpty(this.periodInfo) && this.scheduleData.SCHEDULE_APPLY_FLAG === 'N');
    },
  },
  watch: {
    periodInfo: {
      handler(value) {
        if (!isEmpty(value)) {
          this.scheduleData = value;
          this.startDatetime = this.scheduleData.SCHEDULE_STARTTIME;
          this.scheduleApplyFlag = value.SCHEDULE_APPLY_FLAG;
          if (value.SCHEDULE_APPLY_FLAG === 'N') {
            this.startDatetime = removeTime(moment(new Date()).add(1, 'days'));
          } else {
            this.$nextTick(() => {
              this.$refs.periodSettingCmp.setPeriodSettingData(this.scheduleData);
            });
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.open();
    },
    onClosePopup() {
      this.reset();
      this.$refs.slidingPopup.visible = false;
    },
    reset() {
      this.scheduleData = {};
      this.$refs.periodSettingCmp.init();
    },
    /**
     * 설정한 주기 정보를 저장한다.
     * @author yelim
     * @return {[type]} [description]
     */
    onClickSaveButton() {
      const params = [];
      const settingPeriodInfo = this.$refs.periodSettingCmp.getPeriodSettingData();
      settingPeriodInfo.SCHEDULE_STARTTIME = getDateToString(this.startDatetime);
      if (this.isEditMode) {
        settingPeriodInfo.SCHEDULE_APPLY_FLAG = 'N';
      } else {
        settingPeriodInfo.SCHEDULE_APPLY_FLAG = 'Y';
      }
      const basicinfoSubIdArr = Object.keys(settingPeriodInfo);
      basicinfoSubIdArr.forEach((item) => {
        params.push({
          basicinfoSubid: item,
          basicinfoSubvalueString: settingPeriodInfo[item],
        });
      });
      EventGuideSettingsAPI.setBasicinfoSetForGuide(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '임계치 가이드 주기', true));
          this.onClosePopup();
          this.$emit('reload');
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '임계치 가이드 주기', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '임계치 가이드 주기', false));
        throw new Error(e);
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/operation/BasicInfoSettings/EventPredictSetting/GuideSetting/popup/PeriodSettingPopup.vue